import { render, staticRenderFns } from "./UnitResident.vue?vue&type=template&id=941e7c6a&scoped=true&"
import script from "./UnitResident.vue?vue&type=script&lang=js&"
export * from "./UnitResident.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/projectunit.css?vue&type=style&index=0&id=941e7c6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941e7c6a",
  null
  
)

export default component.exports